import { Controller } from "@hotwired/stimulus"

// Shared modal controller for consistent modal behavior across the app
// Usage:
//   <div data-controller="modal">
//     <button data-action="click->modal#open">Open Modal</button>
//     <div data-modal-target="dialog" class="hidden ...">
//       <div data-modal-target="backdrop" class="fixed inset-0 bg-gray-500 bg-opacity-75"></div>
//       <div class="modal-content">
//         <button data-action="click->modal#close">Close</button>
//       </div>
//     </div>
//   </div>

export default class extends Controller {
  static targets = ["dialog", "backdrop"]

  open(event) {
    if (event) event.preventDefault()
    this.dialogTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.dispatch("opened")
  }

  close(event) {
    if (event) event.preventDefault()
    this.dialogTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.dispatch("closed")
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeOnBackdrop(event) {
    if (this.hasBackdropTarget && event.target === this.backdropTarget) {
      this.close()
    }
  }
}
